import React from 'react';
import PropTypes from 'prop-types';
import classes from './Station.module.css';

const Station = props => {
  const {
    active,
    flexBasis,
    station,
    employee,
    onClick,
    isEmployee,
    isTableAssigned,
    revenueCentersMap,
  } = props;

  const clickHandler = () => {
    onClick && onClick(isEmployee ? employee : station);
  };

  const styles = {
    borderColor: active ? '#ad0028' : '#FFF',
    width: flexBasis,
    backgroundColor: isTableAssigned ? '#d3d3d3' : '#FFF',
  };

  return (
    <div
      onClick={clickHandler}
      className={classes.container}
      style={styles}>
      {isEmployee
        ? <EmployeeCard employee={employee} />
        : <StationCard station={station} revenueCentersMap={revenueCentersMap} />
      }
    </div >
  );
};

export default Station;

Station.propTypes = {
  active: PropTypes.bool.isRequired,
  flexBasis: PropTypes.any,
  onClick: PropTypes.func.isRequired,
  station: PropTypes.object,
  employee: PropTypes.object,
  isTableAssigned: PropTypes.bool,
  revenueCentersMap: PropTypes.instanceOf(Map),
};

Station.defaultProps = {
  active: false,
  flexBasis: '30%',
  onClick: () => { },
  station: {},
  employee: {},
  isTableAssigned: false,
  revenueCentersMap: new Map(),
};

const EmployeeCard = ({ employee }) => {
  const { posId, firstName, lastName } = employee || {};
  return (
    <div className={classes.innerContainer}>
      <span className={classes.name}>{posId}</span>
      <span className={classes.name}>{lastName},</span>
      <span className={classes.name}>{firstName}</span>
    </div>
  );
};

EmployeeCard.propTypes = {
  employee: PropTypes.object.isRequired,
};

EmployeeCard.defaultProps = {
  employee: {},
};

const StationCard = ({ station, revenueCentersMap }) => {
  const { number, revenueCenterId } = station || {};
  const revenueCenterName = revenueCentersMap.has(revenueCenterId) ? revenueCentersMap.get(revenueCenterId) : '';

  return (
    <div className={classes.innerContainer}>
      <span className={classes.tableNum}>{number}</span>
      {revenueCenterName && <span className={classes.revCenterName}>({revenueCenterName})</span>}
    </div>
  );
};

StationCard.propTypes = {
  station: PropTypes.object.isRequired,
  revenueCentersMap: PropTypes.instanceOf(Map),
};

StationCard.defaultProps = {
  station: {},
  revenueCentersMap: new Map(),
};
